import styles from './Loader.module.scss';
import classNames from 'classnames';

interface LoaderProps {
  className?: string;
  scale?: number;
}

export default function Loader({ className, scale = 1 }: LoaderProps) {
  return (
    <div
      className={classNames(styles.root, className && className)}
      style={{ width: scale * 280 }}
    >
      <div
        className={styles.wrapper}
        style={{ transform: `scale(${scale})` }}
      >
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
      </div>
    </div>
  );
}
